"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  send: function send(data) {
    return request.post('subscriptions/send', data);
  }
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kIiwiZGF0YSIsInJlcXVlc3QiLCJwb3N0IiwiZXhwb3J0cyIsIl9kZWZhdWx0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMvY2xpZW50L21vZHVsZXMvQ29udGVudC9TdWJzY3JpcHRpb24vU3Vic2NyaXB0aW9uQWN0aW9ucy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XHJcbiAgICBzZW5kOiAoZGF0YSkgPT4gcmVxdWVzdC5wb3N0KCdzdWJzY3JpcHRpb25zL3NlbmQnLCBkYXRhKSxcclxufVxyXG4iXSwibWFwcGluZ3MiOiI7Ozs7OztlQUFlO0VBQ1hBLElBQUksRUFBRSxTQUFBQSxLQUFDQyxJQUFJO0lBQUEsT0FBS0MsT0FBTyxDQUFDQyxJQUFJLENBQUMsb0JBQW9CLEVBQUVGLElBQUksQ0FBQztFQUFBO0FBQzVELENBQUM7QUFBQUcsT0FBQSxjQUFBQyxRQUFBIn0=